import {openDB, idb} from 'idb';

import JavascriptHelpers from '../components/lib/Javascript/JavascriptHelpers';
import ServiceDataResponse from '../models/ServiceDataResponse';
import ServiceResponse from '../models/ServiceResponse';

const DB_NAME = "obsDocDb";
const DEFAULT_OBJECT_STORE = "obsDocument";

// indexes e.g. {field: "offlineId", name: "offlineId", unique: true}
export default class LocalQueuedDbService
{
    constructor()
    {
        this.defaultObjectStore = DEFAULT_OBJECT_STORE;
        this.dbName = DB_NAME;
        this.indexes = [
            {field: "docId", name: "docId", unique: true}
        ]
        this.idb = {
            db: openDB(DB_NAME, 1,{  
                upgrade: (db, oldVersion, newVersion, transaction) => {
                    switch(oldVersion)
                    {
                        case 0:
                            
                             const store = db.createObjectStore(DEFAULT_OBJECT_STORE) 
                             if (this.indexes)
                             {
                                this.indexes.forEach((i) => {
                                    store.createIndex(i.field, i.name, {unique: i.unique} )
                                })
                             }
                            // fall through so that we can upgrade.
                        case 1:
                            break;
                        default:
                            console.log("unknown db version");
                    }

                }
            })
        };
    }


    async hasDocument(gcid, docId)
    {
        try
        {
            var idb = await this.idb.db;
            var resultData = await idb.get(DEFAULT_OBJECT_STORE, docId);
            var hasDoc = (typeof(resultData) != 'undefined' && resultData != null)
            return ServiceDataResponse.toServiceDataResponse(hasDoc, "Document " + docId + " fetched.", false);
        }
        catch(e)
        {
            msgs = [e.message];
            msgs.unshift("Problem fetching Document by id " + docId + ". ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }



    async addDocument(gcid, dataUri, docId)
    {
        try
        {
            var idb = await this.idb.db;
            var result = await idb.add(DEFAULT_OBJECT_STORE, dataUri, docId);
            return ServiceResponse.toServiceResponse("Document added", false);
        }
        catch(e)
        {
            msgs = new [e.message];
            msgs.unshift("Problem adding Document.");
            return ServiceResponse.toServiceResponse(msgs, true);
        }

    }

    async fetchDocument(gcid, docId)
    {
        try
        {
            var idb = await this.idb.db;
            var resultData = await idb.get(DEFAULT_OBJECT_STORE, docId);
            return ServiceDataResponse.toServiceDataResponse(resultData, "Document " + docId + " fetched.", false);
        }
        catch(e)
        {
            msgs = new [e.message];
            msgs.unshift("Problem fetching Document by id " + docId + ". ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }

    async deleteDocument(docId)
    {
        try
        {
            var idb = await this.idb.db;
            var result = await idb.delete(DEFAULT_OBJECT_STORE, docId);   
            return ServiceResponse.toServiceResponse("Document " + docId + " removed successfully.", false); 
        }
        catch(e)
        {
            msgs = new [e.message];
            msgs.unshift("Problem removing Document " + docId + ". ", true);
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }



}



